<template>
  <div class="app">
    <Auth />
    <Border />

    <!--xs only-->
    <XsHeader v-if="$vuetify.breakpoint.xsOnly" :navTabs="navTabs" />
    <!--xs only-->

    <!--sm and up-->
    <div
      v-else-if="websiteFormat != 'store_info_rewards'"
      ref="fixedRef"
      class="z-axis-stack-top"
    >
      <TopStrip v-if="$route.name !== 'home'">
        <v-container>
          <Search />
        </v-container>
      </TopStrip>
      <SearchResults :bigBannerResults="!fix && $route.name === 'home'" />
      <Header v-if="$route.name === 'home'" :fix="fix" :navTabs="navTabs" />
      <Navigation
        v-if="$route.name !== 'home'"
        :fix="true"
        :navTabs="navTabs"
      />
    </div>
    <div v-else ref="fixedRef" class="z-axis-stack-top">
      <AboutTopStrip />
    </div>
    <!--sm and up-->

    <v-container :class="overlay" fluid>
      <v-row
        class="position-relative"
        :class="isRouteNeedingTopMarginSoMainContentIsBelowFixedHeader"
        style="flex-wrap: unset"
      >
        <!--sm and up-->
        <div
          v-if="
            $vuetify.breakpoint.smAndUp &&
            navRoute &&
            websiteFormat === 'all_items'
          "
          class="d-flex flex-nav justify-center"
        >
          <SideNav v-if="sideNavRoute" :fix="fix" class="flex-nav" />
          <MenuSideNav v-if="$route.name === 'menu'" />
          <AccountSideNav v-if="$route.name === 'account'" />
        </div>
        <AccountSideNav
          v-if="
            $vuetify.breakpoint.smAndUp &&
            $route.name === 'account' &&
            websiteFormat !== 'all_items'
          "
        />

        <!--sm and up-->

        <div class="flex-1">
          <div
            class="align-content-space-between d-flex flex-column min-height"
          >
            <div class="background-color-seashell flex-1">
              <router-view />
            </div>
            <Footer :class="hideFooterRoutes" />
          </div>
        </div>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import AccountSideNav from "@/components/AccountSideNav.vue";
import Auth from "@/components/Auth/index.vue";
import Border from "@/elements/Border.vue";
import Footer from "@/components/UI/Footer.vue";
import Header from "@/components/Header/Header.vue";
import MenuSideNav from "@/components/MenuSideNav.vue";
import Navigation from "@/components/Navigation/index.vue";
import SearchResults from "@/components/Search/Results/index.vue";
import SideNav from "@/components/Navigation/SideNav.vue";
import XsHeader from "@/components/Header/Xs/Header.vue";
import Search from "@/components/Search/index.vue";
import TopStrip from "@/components/TopStrip/index.vue";
import AboutTopStrip from "@/components/About/AboutTopStrip.vue";

export default {
  name: "Store",
  components: {
    AboutTopStrip,
    TopStrip,
    Search,
    AccountSideNav,
    Auth,
    Border,
    Footer,
    Header,
    MenuSideNav,
    Navigation,
    SearchResults,
    SideNav,
    XsHeader
  },
  computed: {
    ...mapGetters({
      popular: "popular/popular",
      promotions: "promotions/promotions"
    }),
    ...mapState({
      menu: (state) => state.menu.items,
      departments: (state) => state.departments.data,
      searchProducts: (state) => state.search.products,
      websiteFormat: (state) =>
        state.store.info.store_info.customization?.website.style
          .website_format ?? "all_items",
      storeInfo: (state) => state.store.info
    }),
    hideFooterRoutes() {
      const routesToHideFooter = ["cart", "search", "confirmed"];
      return routesToHideFooter.includes(this.$route.name) ? "d-none" : "";
    },
    isRouteNeedingTopMarginSoMainContentIsBelowFixedHeader() {
      const routesWithoutFixedHeader = ["home", "search"];
      if (this.$route.name === "confirmed") return "";
      return routesWithoutFixedHeader.includes(this.$route.name)
        ? ""
        : "super-important-margin-top-for-fixed-nav-height";
    },
    navRoute() {
      const routes = ["about", "checkout", "confirmed", "departments", "terms"];
      return !routes.includes(this.$route.name);
    },
    navTabs() {
      return [
        "home",
        ...(this.popular ? ["popular"] : []),
        "departments",
        ...(this.menu && this.menu.length
          ? this.storeInfo.menu_as_featured
            ? ["featured"]
            : ["menu"]
          : []),
        ...(this.promotions ? ["deals"] : []),
        "favorites"
      ];
    },
    overlay() {
      return this.searchProducts.length && this.$vuetify.breakpoint.smAndUp
        ? "dimmed"
        : "";
    },
    sideNavRoute() {
      const sideNavRoutes = [
        "category",
        "department",
        "deals",
        "favorites",
        "home",
        "popular",
        "promotion"
      ];
      return sideNavRoutes.includes(this.$route.name);
    }
  },
  created() {
    this.init();
    document.addEventListener("scroll", this.handleScroll);
  },
  data() {
    return {
      fix: false
    };
  },
  destroyed() {
    document.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    delayCartInitalization() {
      /*
       *
       * this is so src/views/Home.vue watch on
       * cart will work and trigger url lookup
       *
       */
      setTimeout(() => this.$store.commit("cart/INIT_CART_PRODUCTS"), 1000);
    },
    handleScroll() {
      const fixedRefBottomPos =
        this.$refs &&
        this.$refs.fixedRef &&
        this.$refs.fixedRef.getBoundingClientRect().bottom;
      this.fix =
        fixedRefBottomPos < (this.websiteFormat === "all_items" ? 152 : 160);
    },
    init() {
      this.$store.dispatch("departments/fetch");
      this.$store.dispatch("popular/fetch");
      this.$store.dispatch("promotions/fetch");
      this.$store.dispatch("promotions/fetchSharedLibraryPromotions");
      if (this.websiteFormat === "liquor")
        this.$store.dispatch("template/fetch", 1);
      if (this.websiteFormat === "tobacco")
        this.$store.dispatch("template/fetch", 22);
      const session = sessionStorage.getItem("bnJzLXNlc3Npb24=");
      const authenticatedUser =
        sessionStorage.getItem("cmVhbF91c2Vy") === "dHJ1ZQ==";
      const stripeReturnUrl = this.$route.name === "confirmed";
      if (session) {
        !stripeReturnUrl && this.$store.dispatch("cart/fetch");
        this.$store.dispatch("favorites/fetch");
      } else {
        // this.$store.commit("cart/INIT_CART_PRODUCTS");
        this.$store.commit("favorites/INIT");
        this.delayCartInitalization();
      }
      if (authenticatedUser) {
        this.$store.dispatch("user/fetch");
        this.$store.dispatch("orders/fetch");
      }
      this.handleScroll();
    }
  },
  watch: {
    $route(to) {
      if (to.name === "home" && this.websiteFormat === "all_items") {
        this.fix = false;
      }
    }
  }
};
</script>

<style>
.app {
  background-color: var(--color-seashell);
  position: relative;
  overflow-x: hidden;
}

.dimmed {
  position: relative;
}

.dimmed:after {
  content: " ";
  position: absolute;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
}

.flex-nav {
  /* if you change number here to widen sidenav */
  flex: 0 0 256px;
  /* then must also change width in all sidenav components */
}

.footer-height {
  height: var(--footer-height);
}

.margin-bottom {
  margin-bottom: var(--footer-height);
}

.min-height {
  min-height: 100vh;
}

.super-important-margin-top-for-fixed-nav-height {
  /*margin-top: 182.67px;*/
  margin-top: v-bind(
    "websiteFormat === 'store_info_rewards' ? '90px' : '173px'"
  );
}

@media (min-width: 668px) {
  .super-important-margin-top-for-fixed-nav-height {
    margin-top: v-bind(
      "websiteFormat === 'store_info_rewards' ? '65px' : '150px'"
    );
  }
}

.swiper-nav-button-content-max-width {
  max-width: 100px;
}

.z-axis-stack-top {
  position: relative;
  z-index: 1;
}
</style>
